import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_INVOICES';

export async function getAllInvoices(
    userToken: string,
    optionalProps: string,
    page: number,) {
    try {
        const response = await axios.get(
            `${URL}/invoices/?page=${page}${optionalProps}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des factures',
            error: error
        });
    }
}
